const generateObjectId = (padding = 0, forcePadding = false) => {
    // Add padding when u generate multiple object_id at the same time just for the case
    const id = new Date().getTime() + "_" + Math.floor(Math.random() * 100000);
    forcePadding = forcePadding || padding
    return forcePadding ? id + '_' + padding : id;
} 

export default generateObjectId;